<template>
  <div>
    <div class="bd-header bd-header_village">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/village/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-village">
      <div class="bd-village__top">
        <div class="bd-village__top-bg"></div>
        <div class="bd-village__top-wrap">
          <div class="bd-village__top-type">Лайфхак</div>
          <div class="bd-village__top-title">Руководители — о том, как отвлекаться от работы</div>
          <div class="bd-village__top-date">вчера в&nbsp;11:00</div>
        </div>
      </div>
      <div class="bd-village__p">Редкий офисный сотрудник может провести
        весь день, не отрываясь от дел, вероятно, он успеет
        проверить соцсети и несколько раз выйти покурить с коллегами.
        Но такие перерывы не обязательно вредны, они помогают
        ненадолго отвлечься и потом вернуться к работе немного отдохнувшим. </div>

      <buzzCode @ready="ready" :id="id"></buzzCode>

      <div class="bd-village__p">Руководители, которые много
        работают, рассказали о том, как они делают перерывы в течение
        дня и как стоит просматривать соцсети или общаться с
        коллегами, чтобы восстановить силы.</div>
      <div class="bd-village__separator"></div>
      <div class="bd-village__person">
        <div class="bd-village__person-name">Эльвира Саярова</div>
        <div class="bd-village__person-desc">
          руководитель направления корпоративных коммуникаций Рокетбанка
        </div>
      </div>
      <div class="bd-village__p">Работа в офисе напрягает ум, поэтому
        лучший отдых — радикальная смена деятельности, например
        физические нагрузки. В течение дня можно выйти на прогулку
        по парку, помедитировать или даже позаниматься на турниках.
        Пока тело занято своим делом, мозг перезагружается и
        лучше работает: при физических нагрузках мозг работает аж на 40 %
        быстрее и легче принимает решения, а глубокое дыхание
        помогает нервной системе расслабиться. Поэтому в «Рокете» аж три
        шведские стенки, проходят занятия йогой, в том числе
        дистанционно, есть корпоративный фитнес.</div>
      <div class="bd-village__p">Посмотреть новости и отвлечься
        на соцсети не так помогает и, согласно исследованиям в книге
        «Думай как математик», скорее способствует рассеиванию
        внимания и потере концентрации. Для работы с информацией
        продуктивнее выделять отдельное время. Лучше чаще
        общаться с коллегами, обсуждать проекты за игрой в приставку или
        кикер, загорать на веранде и пить вкусный смузи: вы все
        еще работаете, обсуждаете важные решения, но отвлеклись от
        более рутинных дел, а значит, набираетесь сил и идей,
        чтобы сделать свою работу еще лучше. Сейчас очень много
        литературы и статей на тему личной эффективности в
        работе, например про четырехчасовой рабочий день. Вся суть сводится
        к простой мысли, что если не изводить себя рутиной,
        грамотно расставить перерывы и сделать свою работу разнообразной,
        то эффективность вырастает очень сильно. Экономить на
        отдыхе означает в один день заболеть от усталости и стресса, а в
        этом нет никакого смысла ни с человеческой
        стороны, ни со стороны бизнеса.</div>
      <div class="bd-village__person">
        <div class="bd-village__person-name">Евгения Голева</div>
        <div class="bd-village__person-desc">
          менеджер по взаимодействию с разработчиками, Lamoda
        </div>
      </div>
      <div class="bd-village__p">Мне известна техника «pomodoro»,
          когда вы работаете 25 минут, а потом пять минут отдыхаете.
        Также мы все знаем со школы, что после 45 минут мозгу нужна
        передышка. Я стараюсь держаться внутри этих рамок и делать
      перерывы раз в час или в полчаса.</div>
      <div class="bd-village__p">Для тех, кто работает много
          за монитором, хорошей разгрузкой может быть прогулка по этажам с
        разными мелкими задачками — навестить коллег, договориться
        о чем-то, поздравить с днем рождения. Хорошие отношения
        обычно помогают работе. Так что это будет, с одной стороны,
        переключение, а с другой — польза делу. Так же работают
        походы за чаем или в курилку. Многие важные вопросы обсуждаются
        там. Если ни то ни другое не подходит, можно пригласить
        коллегу прогуляться вокруг здания или зайти в ближайшее кафе
        за десертом. Те, кто много работает с людьми, могут зайти
        посидеть в тишине в релакс-комнате минут 10–15 или воспользоваться
      массажными креслами на этажах.</div>
      <div class="bd-village__p">Новостные сайты редко когда радуют
          хорошими новостями. Можно выделить себе пять-десять минут
        после обеда или вечером, чтобы пробежаться по главным событиям.
        Мало кто может противостоять соблазну соцсетей, я
        думаю, что здесь главное — чередовать: в один перерыв проверить
        страничку в Facebook, в другой — сходить прогуляться. В
        конце концов, соцсети — большой источник дофамина, им
        можно подзаряжаться для выполнения рабочих задач. Главное — не
      увлекаться, а если не получается, ставить таймер.</div>
      <div class="bd-village__person">
        <div class="bd-village__person-name">Илья Мусатов</div>
        <div class="bd-village__person-desc">руководитель LensDay.ru</div>
      </div>
      <div class="bd-village__p">Хороший способ отвлечься от работы —
          гимнастика для глаз! Это очень полезно. Основная
        нагрузка на зрение при работе в офисе — это длительное удержание
        фокуса в одной точке: глаза напрягаются, и чем дольше,
      тем сильнее.</div>
      <div class="bd-village__p">В офисе необязательно как идиот сидеть
          за столом и водить глазами туда-сюда. Можно просто
        закрыть глаза руками, сесть в позе сильно задумавшегося человека:
        мол, не отвлекайте меня, вот-вот мысль придет! Либо
        встать с чашкой кофе у окна и смотреть на проезжающие машины.
        Это немного выдергивает из рутины и дает возможность
      отвлечься от дел.</div>
      <div class="bd-village__separator bd-village__separator_rot"></div>
      <div class="bd-village__bottom">
        <div class="bd-village__bottom-logo">
          <img class="bd-ht__img" src="/pages/village/img/logo.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'village',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_village
      background-color #003366
      & ^[1]__menu
        fill white
      .bd-ht__img
        width 40%
        height auto
        margin auto
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-village
    font-family sans-serif
    overflow hidden
    text-align left

    &__top
      position relative
      height 100vh
      overflow hidden
      text-align center
      color white

      &-bg
        filter blur(8px)
        transform scale(1.3)
        position absolute
        z-index 1
        width 100%
        height 100vh
        background url(/pages/village/img/bg.png) no-repeat 50% 50%
        background-size auto 100%
        &:after
          content: ''
          position absolute
          top 0
          right 0
          bottom 0
          left 0
          height 100vh
          background rgba(0,0,0,.5)

      &-type
        margin-bottom 8px
        padding-top 70%
        fontSize(16, 14)
        font-weight bold
        text-transform uppercase

      &-title
        font-family serif
        font-weight bold
        fontSize(27, 32)

      &-wrap
        position relative
        z-index 2
        padding 0 22px
        color white

      &-date
        padding-top 10px
        fontSize(16, 14)
        color rgba(white, .5)

    &__p
      padding 0 10px 27px
      font-family "PT Serif", sans-serif
      fontSize(18, 27)
      color black
      &:nth-child(3)
        padding-top 80px

    &__person
      padding 0 10px 20px
      fontSize(16, 20)
      color #8a8a8a

      &-name
        font-weight bold
        text-transform uppercase

    &__separator
      position relative
      height 24px
      margin-bottom 27px
      background url("/pages/village/img/separator.png") center no-repeat
      &:before
      &:after
        content ''
        position absolute
        top 50%
        width 100%
        height 1px
        margin -.5px 20px 0
        border-top 1px solid #e6e6e6
      &:before
        left 50%
      &:after
        right 50%
      &_rot
        transform rotate(180deg)

    &__bottom
      padding 40px 10px
      background-color black
      & ^[0]-ht__img
        opacity .5
</style>
